import { normalizeTextForSearch } from './turkishUtils';

/** Proses adında "parça" ve "baskı" geçiyorsa parça baskı kabul et */
export const isParcaBaskiProsesName = (processName) => {
  const normalized = normalizeTextForSearch(processName || '');
  return normalized.includes('parca') && normalized.includes('baski');
};

/** Beden satırlarını kayıt metnine dönüştür: "SM 30 L/XL 30" */
export const composeBedenDagilimi = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return '';

  const parts = rows
    .map((row) => {
      const bedenAdi = String(row?.bedenAdi || '').trim();
      const adet = parseInt(row?.adet, 10);
      if (!bedenAdi || !Number.isFinite(adet) || adet <= 0) return null;
      return `${bedenAdi} ${adet}`;
    })
    .filter(Boolean);

  return parts.join(' ');
};

/** Kart/liste gösterimi: "SM 15 -- LXL 15 -- 2XL3XL 15" */
export const formatBedenDagilimiDisplay = (text) => {
  const raw = String(text || '').trim();
  if (!raw) return '';

  const rows = parseBedenDagilimi(raw);
  if (!rows.length) return raw;

  const parts = rows
    .map((row) => {
      const bedenAdi = String(row?.bedenAdi || '').trim();
      const adet = parseInt(row?.adet, 10);
      if (!bedenAdi || !Number.isFinite(adet) || adet <= 0) return null;
      return `${bedenAdi} ${adet}`;
    })
    .filter(Boolean);

  return parts.length ? parts.join(' -- ') : raw;
};

/** Kayıt metnini beden satırlarına ayır */
export const parseBedenDagilimi = (text) => {
  const raw = String(text || '').trim();
  if (!raw) return [];

  const tokens = raw.split(/\s+/);
  const rows = [];
  let currentBeden = '';

  tokens.forEach((token) => {
    const asNumber = Number(token);
    if (Number.isFinite(asNumber) && token !== '' && /^-?\d+(\.\d+)?$/.test(token)) {
      if (currentBeden) {
        rows.push({ bedenAdi: currentBeden, adet: String(Math.round(asNumber)) });
        currentBeden = '';
      }
      return;
    }
    currentBeden = currentBeden ? `${currentBeden} ${token}` : token;
  });

  if (currentBeden) {
    rows.push({ bedenAdi: currentBeden, adet: '' });
  }

  return rows;
};

export const sumBedenAdet = (rows) => {
  if (!Array.isArray(rows)) return 0;
  return rows.reduce((total, row) => {
    const adet = parseInt(row?.adet, 10);
    return total + (Number.isFinite(adet) && adet > 0 ? adet : 0);
  }, 0);
};

/** Parça baskı varsayılan beden satırları */
export const defaultParcaBaskiBedenRows = [
  { bedenAdi: 'SM', adet: '' },
  { bedenAdi: 'LXL', adet: '' },
  { bedenAdi: '2XL3XL', adet: '' }
];

export const cloneDefaultParcaBaskiBedenRows = () =>
  defaultParcaBaskiBedenRows.map((row) => ({ ...row }));

/** Sık kullanılan bedenler — hızlı ekleme; serbest giriş kısıtlanmaz */
export const commonBedenSuggestions = ['SM', 'M', 'L', 'L/XL', 'XL', '2XL', '3XL', '2XL/3XL', 'LXL', '2XL3XL'];
